// Shared student cache - loads once, reused across all sections
import { supabase } from '../lib/supabase';

let cache = null;
let loading = false;
let callbacks = [];

export async function getAllStudents() {
  if (cache) return cache;
  if (loading) {
    return new Promise(resolve => callbacks.push(resolve));
  }
  loading = true;
  try {
    const { data } = await supabase.rpc('get_all_active_students');
    cache = data || [];
    callbacks.forEach(cb => cb(cache));
    callbacks = [];
    return cache;
  } catch(e) {
    loading = false;
    return [];
  }
}

export function clearStudentCache() {
  cache = null;
  loading = false;
  callbacks = [];
}
